import Input from "../Component/Input";
import InputMenu from "../Component/InputMenu";
import InsideTextBox from "../Component/InsideTextBox";
import MultitextBox from "../Component/MultitextBox";
import MuSelect from "../Component/MultiSelectCreate";

export const ContactInfo = [
  { tag: Input, img: "phone", label: "mobileNo", name: "mobileNo" },
  { tag: Input, img: "email", label: "emailId", name: "emailId" },

  { tag: Input, img: "city", label: "City", name: "city" },
  { tag: Input, img: "state", label: "State", name: "state" },
  { tag: Input, img: "country", label: "Country", name: "country" },
  { tag: Input, img: "pincode", label: "Pincode", name: "pincode" },
  { tag: Input, img: "pincode", label: "address", name: "address" },

];

